module.exports = __webpack_public_path__ + "static/img/ct_qt_5.4d6aea43.png";